import { Fragment, useState } from "react";

import { getLabel } from "../../../../../../../hooks/use-labels";
import CancelOrderModal from "./CancelOrderModal";
import { useCancelOrderMutation } from "../../../../../../../features/orders/ordersApi";
import { showErrorToast, showSuccessToast } from "../../../../../../../components/Toast";

const CancelOrder = ({ cancellableIds, refetch }) => {
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState("");

  const [cancelOrder] = useCancelOrderMutation();

  const toggleModal = () => {
    setNotification("");
    setModal((prev) => !prev);
  };

  const onConfirmCancelOrder = async () => {
    setLoading(true);

    let cancelled = 0;

    for (const orderId of cancellableIds) {
      try {
        await cancelOrder({ orderId }).unwrap();
        cancelled += 1;
      } catch {
        // counted as a failure below
      }
    }

    setLoading(false);

    const total = cancellableIds.length;

    if (cancelled === total) {
      showSuccessToast("Your order has been cancelled.");
      setModal(false);
      refetch();
      return;
    }

    if (cancelled === 0) {
      setNotification("Your order could not be cancelled. Please try again.");
      return;
    }

    showErrorToast(
      `${cancelled} of ${total} supplier orders were cancelled. The rest could not be cancelled.`
    );
    setModal(false);
    refetch();
  };

  return (
    <Fragment>
      {modal && (
        <CancelOrderModal
          count={cancellableIds.length}
          loading={loading}
          notification={notification}
          onConfirm={onConfirmCancelOrder}
          onClose={toggleModal}
        />
      )}

      <button
        type="button"
        className="ord-btn ord-btn-primary"
        onClick={toggleModal}
      >
        {getLabel("cancelOrderLabel")}
      </button>
    </Fragment>
  );
};

export default CancelOrder;
